import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FaEye,
  FaEyeSlash,
  FaUserMd,
  FaUserInjured,
  FaEnvelope,
  FaLock,
} from "react-icons/fa";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import CommonPatientLogin from "./CommonPatientLogin";

const CommonHospitalLoginPage = () => {
  const [userType, setUserType] = useState("staff");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [hospitalDomain, sethospitalDomain] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [freezeSlider, setFreezeSlider] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [selectHospital, setSelectHospital] = useState([]);
  const [pulseLogo, setPulseLogo] = useState(false);
  const extendedHospitals = [...hospitalDomain, ...hospitalDomain];
  const [isTransitioning, setIsTransitioning] = useState(true);

  // ✅ UPDATED STATES

  // const domainName = window.location.hostname;
  let navigate = useNavigate();

  const headers = {
    headers: { "Content-Type": "application/json" },
  };

  // Logo pulse animation (unchanged)
  useEffect(() => {
    const interval = setInterval(() => {
      setPulseLogo(true);
      setTimeout(() => setPulseLogo(false), 2000);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // ✅ FETCH MULTIPLE HOSPITAL DOMAINS
  useEffect(() => {
    axios
      .post("/api/hospital-domain/get")
      .then((response) => {
        const formattedData = response.data.map((hospitalData) => {
          if (hospitalData?.data && hospitalData?.file_extension) {
            hospitalData.logo = `data:image/${hospitalData.file_extension.toLowerCase()};base64,${hospitalData.data}`;
          }
          console.log(response.data);
          
          return hospitalData;
        });

        sethospitalDomain(formattedData);
      });
  }, []);

  // ✅ AUTO ROTATE LOGO (NO DESIGN CHANGE)

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required"),
    login_password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      hospital_id: "",
      email: "",
      login_password: "",
      hospital_name: "",
      captchaToken: "",
    },
    validationSchema,
    onSubmit: (values) => onHandleSubmit(values),
  });

  const onHandleSubmit = async (values) => {
    console.log(values);
    if (!executeRecaptcha) {
      toast.error("reCAPTCHA not ready yet");
      return;
    }


    const tokenCaptcha = await executeRecaptcha("login");
    formik.values.captchaToken = tokenCaptcha;

    axios
      .post(
        `
      /api/authentication/hospital-api/get-user-for-login`,
        values,
        headers,
      )
      .then((response) => {
        console.log(response.data.hospital_id);
        const token = response.data.token;
        const array1 = response.data.userDetailList;
        setSelectHospital(array1);
        const headers1 = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
        if (array1.length === 0) {
          console.log(response.data.userDetailList);
          const msg = "Please enter valid email";
          toast.error(msg, {
            autoClose: 1000,
            onClose: () => {},
          });
        } else if (array1.length < 2 && array1.length !== 0) {
          console.log(selectHospital);
          values.hospital_id = array1[0].hospital_id;
          const hosName = array1[0].hospital_name;
          sessionStorage.setItem("hospital_name", hosName);
          // console.log(values);

          axios
            .post(
              "/api/authentication/hospital-api/user-login",
              values,
              headers1,
            )
            .then((response) => {
              console.log(response.data);
              sessionStorage.setItem("token", response.data.token);
              sessionStorage.setItem("doctorId", response.data.id);
              sessionStorage.setItem("statusdoctor", response.data.status);
              
              const docAccesslist = response.data.module_access;
              sessionStorage.setItem(
                "docAccesslist",
                JSON.stringify(docAccesslist),
              );
              console.log(response.data.hospital_domain);
              
              const hospitalMasterSettingList =
                response.data.hospital_master_setting;
              sessionStorage.setItem(
                "settings",
                JSON.stringify(hospitalMasterSettingList),
              );
              if (response.data.message === "Login Successfully!") {
                toast.success(response.data.message, {
                  autoClose: 500,
                  onClose: () => {
                    if (response.data.user_type_id === 2) {
                      navigate("/doctorAppointments");
                    } else {
                      navigate("/appointmentsmanagements");
                    }
                  },
                });
              } else {
                toast.error(response.data.message, {
                  autoClose: 2000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (formik.values.hospital_id != null) {
          // console.log(values);
          sessionStorage.setItem("hospital_name", formik.values.hospital_name);
          axios
            .post(
              "/api/authentication/hospital-api/user-login",
              values,
              headers1,
            )
            .then((response) => {
              // console.log(response.data);
              sessionStorage.setItem("token", response.data.token);
              sessionStorage.setItem("statusdoctor", response.data.status);
              sessionStorage.setItem("doctorId", response.data.id);
              const hospitalMasterSettingList =
                response.data.hospital_master_setting;
              sessionStorage.setItem(
                "settings",
                JSON.stringify(hospitalMasterSettingList),
              );
              const docAccesslist = response.data.module_access;
              sessionStorage.setItem(
                "docAccesslist",
                JSON.stringify(docAccesslist),
              );

              if (response.data.message === "Login Successfully!") {
                toast.success(response.data.message, {
                  autoClose: 500,
                  onClose: () => {
                    if (response.data.user_type_id === 2) {
                      navigate("/doctorAppointments");
                    } else {
                      navigate("/appointmentsmanagements");
                    }
                  },
                });
              } else {
                if (formik.values.hospital_id === "") {
                  const message = "Please select hospital";
                  toast.warning(message, {
                    autoClose: 1000,
                  });
                } else {
                  toast.error(response.data.message, {
                    autoClose: 1000,
                  });
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Always start at 0
  useEffect(() => {
    if (hospitalDomain.length > 0) {
      setCurrentIndex(0);
    }
  }, [hospitalDomain]);

  // Auto slide right → left
  useEffect(() => {
    if (hospitalDomain.length <= 1 || freezeSlider) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, [hospitalDomain, freezeSlider]);

  // Seamless infinite loop
  useEffect(() => {
    if (!freezeSlider && currentIndex === hospitalDomain.length) {
      // wait for slide animation to finish
      setTimeout(() => {
        setIsTransitioning(false); // disable animation
        setCurrentIndex(0); // jump instantly

        // re-enable animation after jump
        setTimeout(() => {
          setIsTransitioning(true);
        }, 50);
      }, 1000); // match transition duration
    }
  }, [currentIndex, hospitalDomain.length]);

  return (
    <div className="h-screen flex flex-col">
      {/* Navbar */}
      <div className="fixed top-0 left-0 right-0 z-1000 flex justify-between items-center px-6 py-2 bg-white-A700 shadow-md shadow-indigo-50 border-b border-indigo-200">
        <span
          className={`text-purple-500 text-shadow-md text-xl font-semibold ${pulseLogo ? "animate-pulse" : ""}`}
        >
          DigiTonic
        </span>

        {/* <div className="flex gap-4">
          <button
            onClick={() => setUserType("staff")}
            className={`px-4 py-1 rounded-full border-2 text-sm font-semibold flex items-center gap-2 ${
              userType === "staff"
                ? "bg-cyan-500 text-gray-800 border-cyan-500"
                : "border-cyan-500 text-cyan-500"
            }`}
          >
            <FaUserMd /> Hospital
          </button>

          <button
            onClick={() => setUserType("patient")}
            className={`px-4 py-1 rounded-full border-2 text-sm font-semibold flex items-center gap-2 ${
              userType === "patient"
                ? "bg-cyan-500 text-gray-800 border-cyan-500"
                : "border-cyan-500 text-cyan-500"
            }`}
          >
            <FaUserInjured /> Patient
          </button>
        </div> */}
      </div>

      {/* Main Content */}
      <div className="flex-1 grid grid-cols-2 sm:grid-cols-1 overflow-hidden mt-8">
        {/* LEFT COLUMN (UNCHANGED CSS) */}
        {/* LEFT COLUMN */}
        <div className="flex flex-col items-center justify-center text-center px-10 py-4 bg-gradient-to-br from-blue-100 via-gray-100 to-blue-200">
          {hospitalDomain.length > 0 && (
            <div className="relative w-full overflow-hidden h-48 flex items-center justify-center">
              <div
                className="flex"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`,
                  transition: isTransitioning
                    ? "transform 700ms ease-in-out"
                    : "none",
                }}
              >
                {[...hospitalDomain, ...hospitalDomain].map(
                  (hospital, index) => (
                    <div
                      key={index}
                      className="w-full flex-shrink-0 flex flex-col items-center justify-center text-center px-4"
                      style={{ minWidth: "100%" }}
                    >
                      <img
                        src={hospital.logo}
                        alt="Hospital Logo"
                        className="h-28 object-contain mb-3"
                      />

                      <h1 className="text-4xl font-bold text-gray-800 text-shadow-sm">
                        {hospital.hospital_name}
                      </h1>

                      <p className="text-gray-600 mt-2 text-lg">
                        {hospital.tag_line}
                      </p>
                    </div>
                  ),
                )}
              </div>
            </div>
          )}

          <ToastContainer />
        </div>

        {/* RIGHT COLUMN */}
        <div className="flex items-center justify-center p-8 apointments-bg">
          <div className="w-full max-w-md">
            <div className="bg-white rounded-3xl shadow-xl p-10 border bg-white-A700">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-gray-800">Welcome Back</h2>
                <p className="text-gray-500 text-sm mt-1">Login to continue</p>
              </div>

              {/* TOGGLE */}
              <div className="flex bg-gray-100 rounded-xl p-1 mb-6">
                <button
                  onClick={() => setUserType("staff")}
                  className={`flex-1 py-2 rounded-lg text-sm font-semibold flex items-center justify-center gap-2 transition ${
                    userType === "staff" ? "bg-white shadow text-indigo-600" : "text-gray-500"
                  }`}
                >
                  <FaUserMd /> Hospital
                </button>
                <button
                  onClick={() => setUserType("patient")}
                  className={`flex-1 py-2 rounded-lg text-sm font-semibold flex items-center justify-center gap-2 transition ${
                    userType === "patient" ? "bg-white shadow text-indigo-600" : "text-gray-500"
                  }`}
                >
                  <FaUserInjured /> Patient
                </button>
              </div>

              {userType === "staff" ? (
                <form onSubmit={formik.handleSubmit} className="space-y-4">
                  <div className="relative">
                    <FaEnvelope className="absolute left-3 top-3.5 text-gray-400" />
                    <input
                      name="email"
                      type="email"
                      placeholder="Email address"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      className="w-full pl-10 pr-4 border rounded-xl focus:ring-2 focus:ring-indigo-400 outline-none"
                    />
                  </div>

                  <div className="relative">
                    <FaLock className="absolute left-3 top-3.5 text-gray-400" />
                    <input
                      name="login_password"
                      type={showPass ? "text" : "password"}
                      placeholder="Password"
                      value={formik.values.login_password}
                      onChange={formik.handleChange}
                      className="w-full pl-10 pr-10  border rounded-xl focus:ring-2 focus:ring-indigo-400 outline-none"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPass(!showPass)}
                      className="absolute right-3 top-3.5 text-gray-400"
                    >
                      {showPass ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>

                  {selectHospital.length > 1 && (
                    <Select
                      options={selectHospital.map((h) => ({
                        label: h.hospital_name,
                        value: h.hospital_id,
                        hospital_name: h.hospital_name,
                      }))}
                      onChange={(opt) =>
                        formik.setValues({
                          ...formik.values,
                          hospital_id: opt.value,
                          hospital_name: opt.hospital_name,
                        })
                      }
                      placeholder="Select Hospital"
                    />
                  )}

                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-indigo-600 to-cyan-500 py-2.5 rounded-xl font-semibold shadow-lg hover:from-indigo-700 hover:to-cyan-600"
                  >
                    Login
                  </button>

                  <div className="text-center text-xs text-gray-400 mt-4">
                    🔒 Secure Login • Trusted Hospital Platform
                  </div>
                </form>
              ) : (
                <CommonPatientLogin />
              )}
            </div>

            {/* <p className="text-center text-xs text-gray-500 mt-6">
              © PurpleRadiance Technologies Pvt. Ltd.
            </p> */}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="apointments-bg text-white-A700 py-1.5
       px-3 border-t border-indigo-200">
        <div className="max-w-7xl text-xs text-black-900 mx-auto text-center flex justify-evenly gap-10">
          <p>© All Rights Reserved. PurpleRadiance Technologies Pvt. Ltd.</p>
          <p>Phone: +91 86009 07272 | Email: contact@purpleradiance.com</p>
          <Link to="/admin/login" className="text-black-900 hover:underline">
            Admin Login
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default CommonHospitalLoginPage;
